export default __webpack_public_path__ + "static/media/russian poker-08.8070bbea.png";